// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ug-z","heading":"Vg-z","items":"Wg-z","featureCss":"Xg-z","disabled":"Yg-z","imgCss":"Zg-z"};